/**
 * @generated SignedSource<<31c399a1ef5bf926eb569a2bbd76feb1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PopupDefaultReport_site$data = {
  readonly slug: string;
  readonly url: string;
  readonly reportPopup: {
    readonly rows: ReadonlyArray<{
      readonly popupName: string | null;
      readonly popupGroupName: string | null;
      readonly popupImageUrl: string | null;
      readonly funnelName: string | null;
      readonly readyUser: number;
      readonly pageViewUser: number;
      readonly closeClick: number;
      readonly clickUser: number;
      readonly conversionUser: number;
      readonly impConversionUser: number;
      readonly readyConversionUser: number;
      readonly dropUser: number;
      readonly dropConversionUser: number;
      readonly uniqueUser: number;
      readonly totalConversionUser: number;
      readonly clickUserRate: number;
      readonly conversionClickRate: number;
      readonly conversionImpRate: number;
      readonly conversionDropRate: number;
      readonly totalConversionRate: number;
      readonly mobileRate: number;
      readonly pcRate: number;
      readonly tabletRate: number;
      readonly popupSlug: string | null;
      readonly popupGroupSlug: string | null;
    }>;
    readonly summary: ReadonlyArray<{
      readonly popupName: string | null;
      readonly popupGroupName: string | null;
      readonly popupImageUrl: string | null;
      readonly funnelName: string | null;
      readonly readyUser: number;
      readonly pageViewUser: number;
      readonly closeClick: number;
      readonly clickUser: number;
      readonly conversionUser: number;
      readonly impConversionUser: number;
      readonly readyConversionUser: number;
      readonly dropUser: number;
      readonly dropConversionUser: number;
      readonly uniqueUser: number;
      readonly totalConversionUser: number;
      readonly clickUserRate: number;
      readonly conversionClickRate: number;
      readonly conversionImpRate: number;
      readonly conversionDropRate: number;
      readonly totalConversionRate: number;
      readonly mobileRate: number;
      readonly pcRate: number;
      readonly tabletRate: number;
    }>;
    readonly graph: ReadonlyArray<{
      readonly popupId: number | null;
      readonly popupName: string | null;
      readonly popupGroupName: string | null;
      readonly popupImageUrl: string | null;
      readonly funnelName: string | null;
      readonly readyUser: number;
      readonly pageViewUser: number;
      readonly closeClick: number;
      readonly clickUser: number;
      readonly conversionUser: number;
      readonly impConversionUser: number;
      readonly readyConversionUser: number;
      readonly dropUser: number;
      readonly dropConversionUser: number;
      readonly uniqueUser: number;
      readonly totalConversionUser: number;
      readonly clickUserRate: number;
      readonly conversionClickRate: number;
      readonly conversionImpRate: number;
      readonly conversionDropRate: number;
      readonly totalConversionRate: number;
      readonly mobileRate: number;
      readonly pcRate: number;
      readonly tabletRate: number;
      readonly accessDate: string | null;
    }>;
    readonly summaryGraph: ReadonlyArray<{
      readonly readyUser: number;
      readonly pageViewUser: number;
      readonly closeClick: number;
      readonly clickUser: number;
      readonly conversionUser: number;
      readonly impConversionUser: number;
      readonly readyConversionUser: number;
      readonly dropUser: number;
      readonly dropConversionUser: number;
      readonly uniqueUser: number;
      readonly totalConversionUser: number;
      readonly clickUserRate: number;
      readonly conversionClickRate: number;
      readonly conversionImpRate: number;
      readonly conversionDropRate: number;
      readonly totalConversionRate: number;
      readonly mobileRate: number;
      readonly pcRate: number;
      readonly tabletRate: number;
      readonly accessDate: string | null;
    }>;
  };
  readonly " $fragmentType": "PopupDefaultReport_site";
};
export type PopupDefaultReport_site = PopupDefaultReport_site$data;
export type PopupDefaultReport_site$key = {
  readonly " $data"?: PopupDefaultReport_site$data;
  readonly " $fragmentSpreads": FragmentRefs<"PopupDefaultReport_site">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "popupName",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "popupGroupName",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "popupImageUrl",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "funnelName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyUser",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pageViewUser",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closeClick",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clickUser",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversionUser",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "impConversionUser",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "readyConversionUser",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropUser",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dropConversionUser",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uniqueUser",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalConversionUser",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "clickUserRate",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversionClickRate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversionImpRate",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conversionDropRate",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalConversionRate",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mobileRate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pcRate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabletRate",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessDate",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "filter"
    },
    {
      "kind": "RootArgument",
      "name": "kind"
    },
    {
      "kind": "RootArgument",
      "name": "order"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PopupDefaultReport_site",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        },
        {
          "kind": "Variable",
          "name": "kind",
          "variableName": "kind"
        },
        {
          "kind": "Variable",
          "name": "order",
          "variableName": "order"
        }
      ],
      "concreteType": "PopupReport",
      "kind": "LinkedField",
      "name": "reportPopup",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupReportRow",
          "kind": "LinkedField",
          "name": "rows",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "popupSlug",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "popupGroupSlug",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupReportRow",
          "kind": "LinkedField",
          "name": "summary",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupReportRow",
          "kind": "LinkedField",
          "name": "graph",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "popupId",
              "storageKey": null
            },
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PopupReportRow",
          "kind": "LinkedField",
          "name": "summaryGraph",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Site",
  "abstractKey": null
};
})();

(node as any).hash = "b59a255a5b4fb2d36ae9ba04524335e2";

export default node;
